module.exports = "/_next/static/images/ActivateEngagement@2x-20e8ef01eaf6c6e05c531891c49de254.webp";